const SemVer = require('../classes/semver')
const major = (a, loose) => new SemVer(a, loose).major
module.exports = major



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/major.js
// module id = 2453
// module chunks = 0